export const APP_VIEW = {
    web: 'web',
    atBat: 'app/atbat',
    ballpark: 'app/ballpark',
};

export const MEDIA_CONFIG_CONTEXT = {
    landing: 'landing',
    search: 'search',
    playback: 'playback',
    app: 'app',
    reel: 'reel',
    home: 'home',
};

export const SEARCH_ROUTE = '/search';

export const QUERY_PARAMS = {
    query: 'q',
    queryType: 'qt',
    contentPreference: 'cp',
    searchPage: 'p',
    playlistTitle: 'pt',
    feedType: 'ft',
    topicId: 't',
};
